module.exports = __webpack_public_path__ + "img/icon-question-rating-radio_button-active.43d806dd.svg";